/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class s{constructor(s){this.options=s}get hash(){return this.options.hash}}export{s as AAggregateSpatialIndex};
